<template lang="pug">
v-card.rounded-lg(color="white" flat)
  .pa-6
    template(v-if="loading")
      v-skeleton-loader(type="list-item-two-line")
    template(v-else)
      .text-sm.font-medium.neutral500--text.mb-2 {{ title }}
      .d-flex
        .text-g3 {{ value }}
        .text-g3.ml-3.neutral500--text(v-if="suffix") {{ suffix }}
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      required: true,
    },
    suffix: {
      type: String,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>